import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createBooking = (data) => api.post("/bookings", data).then(r => r.data);
export const createContact = (data) => api.post("/contacts", data).then(r => r.data);
